import React from "react";
import Container from "./Container";
import classNames from "classnames";
import { useApplyAfterWidth } from "../utils/hooks";

const SectionLine = ({ variant = "left" }) => {
  const isDesktop = useApplyAfterWidth(768);

  return (
    <Container additionalPx>
      <div className="flex items-center gap-16px">
        {isDesktop && (
          <img
            src="/spacer-rhomb.svg"
            alt="Section line icon"
            className={classNames({
              "order-last": variant === "right",
              hidden: variant === "empty",
            })}
          />
        )}

        <div className="w-full h-2px bg-gold-transparent" />
      </div>
    </Container>
  );
};

export default SectionLine;
